<script lang="ts" setup>
defineProps({
  width: {
    type: String,
    default: '24',
  },
});
</script>

<template>
  <svg
    :width="width"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1076_3263)">
      <path
        d="M13.6913 10.0745C14.8005 10.0745 15.6926 9.17435 15.6926 8.06521C15.6926 6.95607 14.8005 6.0559 13.6913 6.0559C12.5822 6.0559 11.682 6.95607 11.682 8.06521C11.682 9.17435 12.5822 10.0745 13.6913 10.0745ZM7.66342 9.2708C8.9976 9.2708 10.0666 8.19381 10.0666 6.85963C10.0666 5.52545 8.9976 4.44846 7.66342 4.44846C6.32924 4.44846 5.25225 5.52545 5.25225 6.85963C5.25225 8.19381 6.32924 9.2708 7.66342 9.2708ZM13.6913 11.682C12.2205 11.682 9.27086 12.4214 9.27086 13.8922V15.7006H18.1118V13.8922C18.1118 12.4214 15.1622 11.682 13.6913 11.682ZM7.66342 10.8782C5.79074 10.8782 2.03735 11.8186 2.03735 13.6913V15.7006H7.66342V13.8922C7.66342 13.209 7.92865 12.0115 9.56824 11.1033C8.869 10.9586 8.19388 10.8782 7.66342 10.8782Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
